import React from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { HashRouter as Router } from "react-router-dom";

createRoot(document.getElementById("root")).render(
  <Router>
    <App />
  </Router>
);
